// extracted by mini-css-extract-plugin
module.exports = {"aggregatedValuesHolder":"FieldAggregateTextInput_aggregatedValuesHolder__1fgGP","invalid":"FieldAggregateTextInput_invalid__2cS6R"};